//
//
//
//



export default {
  block: ['htmlBlock'],
  props: ['data'],
  methods: {
    getBlockModifiers() {
      let bms = this.block;
      if (this.data.blockModifiers) {
        this.data.blockModifiers.forEach( (blockModifier, index) => {
          bms += ' bm-'+blockModifier;
        });
      }

      return bms;
    },
  }
}



// WEBPACK FOOTER //
// ./components/blocks/Html.vue